import { render, staticRenderFns } from "./OrderProperty.vue?vue&type=template&id=5b15c5fb&scoped=true&"
import script from "./OrderProperty.vue?vue&type=script&lang=ts&"
export * from "./OrderProperty.vue?vue&type=script&lang=ts&"
import style0 from "./OrderProperty.vue?vue&type=style&index=0&id=5b15c5fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15c5fb",
  null
  
)

export default component.exports